import React from "react";
import styled from "styled-components";
import {DataRefreshRatePill, SectionTitle} from "../../Sections";
import ClientsTable from "./ClientsTable";

const Container = styled.div`
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    flex-direction: column;
    overflow: hidden;
    
    .ReactVirtualized__Table__headerColumn:first-of-type, .ReactVirtualized__Table__rowColumn:first-of-type {
        margin-left: 9px;
    }
    .ReactVirtualized__Table__headerColumn, .ReactVirtualized__Table__rowColumn {
        margin-right: 0;
    }
`;

const TitleText = styled.div`
    margin-right: 12px;
`;

const RefreshContainer = styled.div`
    margin-left: auto;
`;

const AllClients = ({userIdentity, sort, allPortfolios, authorActions}) => {
    return (
        <Container className="t-all-portfolios">
            <SectionTitle>
                <TitleText>All Clients</TitleText>
                <RefreshContainer>
                    <DataRefreshRatePill/>
                </RefreshContainer>
            </SectionTitle>
            <ClientsTable userIdentity={userIdentity}
                          sort={sort}
                          authorActions={authorActions}
                          allPortfolios={allPortfolios}/>
        </Container>
    );
};

export default AllClients;
